/* Version: 3.5.155 */
'use client';
import styled from 'styled-components';
import { BREAKPOINTS } from '../../spacing/index.js';
import { typography } from '../../typography/typography.js';

var Backdrop = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__Backdrop",
  componentId: "sc-1u3ezz0-0"
})(["position:fixed;top:0;left:0;right:0;bottom:0;background:", ";opacity:0.5;z-index:99999;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colorPalette.neutralColors.dark.shade_default;
});
process.env.NODE_ENV !== "production" ? Backdrop.displayName = 'Backdrop' : undefined;
var ModalContent = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__ModalContent",
  componentId: "sc-1u3ezz0-1"
})(["font-family:", ";line-height:", ";max-height:100%;width:556px;position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);box-sizing:border-box;background:", ";border:solid 1px ", ";color:", ";overflow:auto;padding:1.5rem;z-index:100000;@media screen and (max-width:", "px){width:95%;}", ""], typography.fontFamily, typography.lineHeight, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colorPalette.neutralColors.light.shade_white;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colorPalette.neutralColors.light.shade_deafult;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_1;
}, BREAKPOINTS.MAX_768, function (_ref5) {
  var modalStyle = _ref5.modalStyle;
  return modalStyle;
});
process.env.NODE_ENV !== "production" ? ModalContent.displayName = 'ModalContent' : undefined;
var CloseButtonWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__CloseButtonWrapper",
  componentId: "sc-1u3ezz0-2"
})(["display:inline-block;width:100%;"]);
process.env.NODE_ENV !== "production" ? CloseButtonWrapper.displayName = 'CloseButtonWrapper' : undefined;
var CloseButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "styledComponents__CloseButton",
  componentId: "sc-1u3ezz0-3"
})(["cursor:pointer;background:none;border-style:none;padding:1rem;position:absolute;top:0.5rem;right:0.5rem;"]);
process.env.NODE_ENV !== "production" ? CloseButton.displayName = 'CloseButton' : undefined;

export { Backdrop, CloseButton, CloseButtonWrapper, ModalContent };
